export enum Title {
    Home = 'Home',
    Advantages = 'Advantages',
    Abonnement = 'Abonnement',
    PartnerConditions = 'Conditions',
    NextStep = 'Prochaines étapes',
    Drilling = 'Forage'
}
